module.exports = __webpack_public_path__ + "static/media/Formato Portabilidad.e5ae2b39.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/Formato Portabilidad.pdf
// module id = 931
// module chunks = 0